"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Analytics;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Analytics(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "analytics"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.741,60.914a2.5,2.5,0,0,0,3.471-.673c3.42-5.065,9.215-11.084,17.266-10.868,5.109.122,9.118,1.57,13,2.971,6.064,2.192,12.333,4.457,21.071.338C81.025,47.743,83.868,38.3,84.636,33.239L87.8,36.985a2.5,2.5,0,1,0,3.821-3.225l-6.873-8.146a2.668,2.668,0,0,0-3.763-.321l-8.124,6.859a2.5,2.5,0,0,0,3.226,3.82l3.535-2.985A20.064,20.064,0,0,1,68.413,48.16c-6.86,3.232-11.441,1.577-17.24-.518-4.056-1.465-8.652-3.126-14.575-3.268-10.324-.229-17.412,6.97-21.53,13.069A2.5,2.5,0,0,0,15.741,60.914Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M92.5,42.5a2.5,2.5,0,0,0-5,0v45H65.833V58.833a2.5,2.5,0,0,0-5,0V87.5H39.167V54.167a2.5,2.5,0,0,0-5,0V87.5H12.5V10a2.5,2.5,0,0,0-5,0V90A2.5,2.5,0,0,0,10,92.5H90a3.549,3.549,0,0,0,2.5-3.216Z"
  })))));
}